import { defineMessages, IntlShape } from "react-intl";

import { getDisplayName } from "@app/util/ui";

enum ViewType {
  COACHING = "coaching",
  DASHBOARD = "dashboard",
  EXECUTIVE_SUMMARY = "executive-summary",
  TASKS = "tasks",
  TIMELINE = "timeline",
}

const messages = defineMessages<ViewType>({
  [ViewType.COACHING]: {
    id: "dashboard.viewType.coaching",
    defaultMessage: "Coaching",
    description: "Coaching View title on the Dashboard page",
  },
  [ViewType.DASHBOARD]: {
    id: "dashboard.viewType.dashboard",
    defaultMessage: "Dashboard",
    description: "Dashboard View title on the Dashboard page",
  },
  [ViewType.EXECUTIVE_SUMMARY]: {
    id: "dashboard.viewType.executiveSummary",
    defaultMessage: "Field Insights",
    description: "Field Insights View title on the Dashboard page",
  },
  [ViewType.TASKS]: {
    id: "dashboard.viewType.tasks",
    defaultMessage: "Tasks",
    description: "Tasks View title on the Dashboard page",
  },
  [ViewType.TIMELINE]: {
    id: "dashboard.viewType.timeline",
    defaultMessage: "Timeline",
    description: "Timeline View title on the Dashboard page",
  },
});

export const getViewTypeDisplayName = (intl: IntlShape, viewType: ViewType) =>
  getDisplayName(intl, messages, viewType, "ViewType");

export default ViewType;
